import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MenuItem from "sushiweb/MenuItem";
import * as RolesActions from "../../../store/actions/Roles";
import Searchbox from "sushiweb/Searchbox";
import { isValidated } from "../../../utils";
import NoFooterModal from "../../Common/NoFooterModal";
import { BottomSectionModal } from "../../../constants/assets/containers";
import Button from "sushiweb/Button";

const AddRolesModal = (props) => {
  const {
    heading,
    handleClose,
    getAllActions,
    getRolesList,
    resetState,
    addRoles,
  } = props;
  const [initialState, setInitialState] = useState({
    roles: [],
    action: "",
  });
  const mandatoryFields = ["action", "roles"];
  const [roles, setRoles] = useState([]);
  const [rolesCopy, setRolesCopy] = useState([]);
  const [actions, setActions] = useState([]);
  const [actionsCopy, setActionsCopy] = useState([]);
  const [error, setError] = useState("");

  const handleSelect = (key, val) => {
    const values = { ...initialState };
    values[key] = val;
    setInitialState(values);
    setRoles(rolesCopy);
    setActions(actionsCopy);
    setError("");
  };

  const checkIfButtonDisabled = () => {
    const validatedState = isValidated(initialState, mandatoryFields);
    return validatedState !== "validated";
  };

  const handleSubmit = () => {
    const payload = { ...initialState };
    addRoles(payload).then((res) => {
      handleClose();
    });
  };

  useEffect(() => {
    getAllActions().then((res) => {
      if (res && res.actions) {
        setActions(res.actions);
        setActionsCopy(res.actions);
      }
    });
    getRolesList().then((res) => {
      if (res && res.roles) {
        setRoles(res.roles);
        setRolesCopy(res.roles);
      }
    });
    return function cleanup() {
      resetState({ state: "allActions" });
    };
  }, []);

  const handleChangeActions = (query) => {
    if (!query) {
      setActions(actionsCopy);
      return;
    }
    // callback function, triggered when user types anything iin the input
    const filteredList = actionsCopy.filter((item) =>
      item.toLowerCase().includes(query.toLowerCase())
    );
    setActions(filteredList);
  };

  const handleChange = (query) => {
    // callback function, triggered when user types anything iin the input
    const filteredList = rolesCopy.filter((item) => item.name.includes(query));
    setRoles(filteredList);
  };

  return (
    <NoFooterModal
      header
      id="addRolesModal"
      heading={heading}
      handleClose={handleClose}
      modalButtons={
        <BottomSectionModal>
          <Button
            onClick={handleSubmit}
            className="sushi-btn"
            data-testid="addRolesSubmitBtn"
            disabled={checkIfButtonDisabled()}
          >
            Submit
          </Button>
        </BottomSectionModal>
      }
    >
      <div onSubmit="return false;" className="mb-20" id="add-roles">
        <Searchbox
          placeholder="Select Action"
          className="sushi-searchbox-compact mb-40"
          helperText=""
          onChange={handleChangeActions}
          onSelect={(e) => handleSelect("action", e)}
          showDropdownArrow={false}
        >
          {actions.map((action, index) => {
            return (
              <MenuItem key={"actions" + index} value={action} label={action} />
            );
          })}
        </Searchbox>
        <Searchbox
          placeholder="Select Roles"
          className="sushi-searchbox"
          tagType="red"
          helperText=""
          type="tag"
          onChange={handleChange}
          onSelect={(e) => handleSelect("roles", e)}
          showDropdownArrow={false}
        >
          {roles.map((role, index) => {
            return (
              <MenuItem
                key={"roles" + index}
                value={role.name}
                label={role.name}
              />
            );
          })}
        </Searchbox>
      </div>
    </NoFooterModal>
  );
};

function mapStateToProps(state) {
  const { Roles } = state;
  return {
    allActions: Roles.allActions,
    rolesList: Roles.rolesList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetState: bindActionCreators(RolesActions.resetState, dispatch),
    getAllActions: bindActionCreators(RolesActions.getAllActions, dispatch),
    getRolesList: bindActionCreators(RolesActions.getRolesList, dispatch),
    addRoles: bindActionCreators(RolesActions.addRoles, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddRolesModal);
